import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/savings-goal-calculator',
  component: () => import('../../routes/SavingsGoalCalculator.svelte'),
  card: {
    id: 'savings-goal-calculator',
    title: 'Savings Goal Calculator',
    description: 'Find out how long it will take to reach your savings goal with compound interest and regular contributions. See your progress year by year.',
    icon: 'savings',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/savings-goal-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Savings Goal Calculator – How Long to Reach My Savings Goal?',
    description: 'Free savings goal calculator to find out how long it takes to reach your savings goal with compound interest and monthly contributions. See year-by-year progress and total interest earned.',
  },
};

export default meta;
